import { stampPlateReducer } from "../reducer/StampPlateReducer";

export const reducer = stampPlateReducer;